import { Message } from './types';
import { translations } from './messages';
import { getCookieValue } from 'utils/cookies';

class I18n {
  private translations = translations;
  private currentLocale: string = this.sanitizeLocale(getCookieValue('tourpilot-lang') ?? localStorage?.getItem('tourpilot-lang') ?? 'es');
  public t = this.getMessages(this.currentLocale);

  getMessages(locale: string): Message {
    const lang = this.sanitizeLocale(locale.split('_')[0]);
    const hasFullLocale = Object.keys(this.translations).includes(locale);
    const hasMainLang = Object.keys(this.translations).includes(lang);
    if (hasMainLang) {
      return { ...this.translations[lang], ...(hasFullLocale && this.translations[locale]) } as Message;
    } else {
      console.error(`Locale '${locale}' not supported. Using default language: es`);
      return this.translations['es'] as Message;
    }
  }

  changeLanguage(locale: string) {
    console.debug(`Change current locale ${this.currentLocale} for ${locale}.`);
    this.currentLocale = this.sanitizeLocale(locale);
    this.t = this.getMessages(this.currentLocale);
  }

  getLocale() {
    return this.currentLocale;
  }

  sanitizeLocale(locale: string) {
    return locale.replace('-', '_');
  }
}

export const i18n = new I18n();
